(function() { window.GUID_2190bb32_52b6_4eb1_b976_8ff6c4ac2752 = { getGuid: function() { return "2190bb32-52b6-4eb1-b976-8ff6c4ac2752"; } }; })();
var CS;
(function (CS) {
    var App;
    (function (App) {
        var Views;
        (function (Views) {
            var _Shared;
            (function (_Shared) {
                var WallSections;
                (function (WallSections) {
                    CS.Controls.Accordion.Events.Ready({
                        selector: 'body',
                        childSelector: '.accordion-leagueschedule',
                        callback: function (accordion, e) {
                            CS.Controls.DropDown.Events.ListItemClicked({
                                selector: "#dropdown-matches-formats-" + accordion.ContentId,
                                callback: (list, e) => updateFilter(accordion, e.jqueryEventObject, e.data.extraValues)
                            });
                        }
                    });
                    function updateFilter(accordion, e, extraData) {
                        CS.Lag('league-schedule-filter', 50, function () {
                            if (extraData != null) {
                                let { url } = extraData;
                                if (url == null)
                                    url = extraData.Url;
                                if (url != null) {
                                    accordion.Data.RefreshUrl = url;
                                    accordion.RefreshContent();
                                }
                            }
                        });
                    }
                })(WallSections = _Shared.WallSections || (_Shared.WallSections = {}));
            })(_Shared = Views._Shared || (Views._Shared = {}));
        })(Views = App.Views || (App.Views = {}));
    })(App = CS.App || (CS.App = {}));
})(CS || (CS = {}));

//# sourceMappingURL=league-schedule.js.map
